import { Dialog, DialogContent, DialogTitle, Popover, Tooltip, } from "@mui/material";
import { ColDef, ColumnApi, GridApi, ICellRendererParams, ValueGetterParams } from "ag-grid-community";
import _, { set } from 'lodash';
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import { LoadOrganizations, LoadPlans, LoadProviders, } from "../../actions";
import Config from "../../config";
import { setHeaderCount, setHeaderTitle, setRefreshHandler, } from "../../helpers/header.helper";
import setToast from "../../helpers/toaster.helper";
import { AddNumberIcon, CancelIcon, CancelSubscriptionIcon, DisableIcon, DownloadedIcon, EditIcon, MultiSelectCrossIcon, PlanDetailsIcon, ReHostIcon, RechargeIcon, SettingsIcon, TransactionHistoryIcon } from "../../icon";
import { LandlineSubscriberFormData, ProductType, } from "../../models/add-phone-number.model";
import { OrganizationModel, mapToOrganizationDetails, } from "../../models/organization.model";
import { PhoneNumberModel, PhoneNumberStatus, PhoneNumbergroup, ProviderModel, mapToPhoneNumber, maptoPhoneNumberGroups, } from "../../models/phone-number.model";
import { PlanModel, PlanType, mapToPlan } from "../../models/plans.model";
import { PlanHistoryModel, RechargeStatus, } from "../../models/transaction-history.model";
import { OrganizationService } from "../../services/OrganizationService";
import { PhoneNumberService } from "../../services/PhonenumberService";
import { UtilityService } from "../../services/UtilityService";
import ChargebeeService from "../../services/chargebee.service";
import { IPaymentProps } from "../payment/payment.component";
import { AppRoutes } from '../routes/route.path';
import ConfirmDialog from "../shared/confirm-dialog.component";
import { ActionLabels, GridStatusLabelVariant, PhoneNumberStatusLabels, PlansHeaders, ProductTypeLabel, ToasterTexts, appNote, buttonLabels, emptyLabels, pageTitles, } from "../shared/constants";
import FilterComponent from "../shared/filters/filter.component";
import { CustomFilterCategory, FilterCategory } from "../shared/filters/filter.model";
import GridComponent from "../shared/grid";
import { MenuItemRenderer } from "../shared/grid/actionsMenuItemRendrer";
import { ActionsRenderer } from '../shared/grid/actionsRenderer';
import { HeaderTemplate, dateComparator } from "../shared/grid/grid.services";
import { StatusRenderer } from "../shared/grid/statusRenderer";
import PageHeaderComponent from "../shared/page-header.component";
import PhoneSubscriberDetailsComponent from "../shared/phone-subscriber-details.component";
import SubpageHeaderComponent from "../shared/subpage-header.component";
import { ToasterType } from "../shared/toaster/toaster.model";
import CurrentPlanDetails from "./current-plan-details.component";
import EditPhoneNumber from "./edit-phone-number.component";
import PhoneNumberSettings from "./settings.component";
import { UserService } from "../../services/UserService";
import * as selector from "../../selectors/selectors";
import { useDispatch } from "react-redux";
import { updateOrganizationPhoneNumberGroups, updateOrganizationsphoneNumbers, updatePhonenumberSelectedOrgIDs } from "../../reducers/reducer";
import { exportToExcel } from "../../helpers/ExportToExcel";
import moment from "moment";
import PhoneNumberGroups from "../PhoneNumberGroup";
import { PhoneNumberGroupService } from "../../services/PhoneNumberGroupsServices";

interface IProps { }

const PhoneNumbersComponent = (props: IProps) => {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
	const Organizations: OrganizationModel[] = useSelector(selector.organizations)
	const Providers: ProviderModel[] = useSelector(selector.providers)
	const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)
	const SelectedOrganizations: string[] = useSelector(selector.SelectedPhonenumberOrganizations)
	const organizationPhonenumbers: PhoneNumberModel[] = useSelector(selector.OrganizationsphoneNumbers)
	const OrganizationPhoneNumberGroups = useSelector(selector.OrganzationPhoneNumberGroups);
	const IsDarkMode: boolean = useSelector(selector.isDarkMode)


	const [gridApi, setGridApi] = useState<GridApi>(null)
	const [columnApi, setColumnApi] = useState<ColumnApi>(null)
	const [CurrentPhoneNumber, setCurrentPhoneNumber] = useState<PhoneNumberModel | undefined>();
	const [currentPlanDetails, setCurrentPlanDetails] = useState<PlanHistoryModel | undefined>();
	const [EditPhoneNumberData, setEditPhoneNumberData] = useState<PhoneNumberModel | undefined>();
	const [PhoneNumbers, setPhoneNumbers] = useState<PhoneNumberModel[]>([]);
	const [PhoneDetailsData, setPhoneDetailsData] = useState<LandlineSubscriberFormData>();
	const [TransactionHistory, setTransactionHistory] = useState<PlanHistoryModel>();
	const [Plans, setPlans] = useState<FilterCategory[]>([])
	const [CurrentAddons, setCurrentAddons] = useState<PlanModel[]>([])
	const [addons, setAddons] = useState<PlanModel[]>([])
	const [showerrorCancelDialog, setshowerrorCancelDialog] = useState<boolean>(false)
	const [ShowCancelAddOnConfirmation, setShowCancelAddOnConfirmation] = useState<boolean>(false)
	const [IsLoading, setIsLoading] = useState<boolean>(false)
	const [IsDeleted, setIsDeleted] = useState<boolean>(false)
	const [ButtonName, setButtonName] = useState<string>("")
	// const [DialogAction, setDialogAction] = useState<string>("")
	const [Text, setText] = useState<string>("")
	const [Show, setShow] = useState<boolean>(false)
	const [ShowCancelSubscriptionConfirmation, setShowCancelSubscriptionConfirmation] = useState<boolean>(false)
	const [editPhoneNumber, setEditPhoneNumber] = useState<boolean>(false)
	const [ShowSettings, setShowSettings] = useState<boolean>(false)
	const [ShowTransactionHistory, setShowTransactionHistory] = useState<boolean>(false)
	const [MobileMenu, setMobileMenu] = useState<boolean>(false)
	const [ShowPlansDialog, setShowPlansDialog] = useState<boolean>(false)
	const [ViewDetails, setViewDetails] = useState<boolean>(false)
	const [SearchText, setSearchText] = useState<string>("")
	const [PhoneNumberName, setPhoneNumberName] = useState<string>("")
	const [SelectedPhoneNumberId, setSelectedPhoneNumberId] = useState<string>("")
	const [SubscriptionIDToCancel, setSubscriptionIDToCancel] = useState<string>("")
	const [anchorEl, setAnchorEl] = useState<Element | null>();
	const [ShowFilterOptions, setShowFilterOptions] = useState<boolean>(false);
	const [filterOptions, setFilterOptions] = useState<CustomFilterCategory[]>([]);
	const [selectedFilterTypes, setSelectedFilterTypes] = useState<string[]>([]);
	const [searchValue, setSearchValue] = useState<any>();
	const [selectedOrgIds, setSelectedOrgIds] = useState<string[]>([]);
	const [ShowMultiActionButtons, setShowMultiActionButtons] = useState<boolean>(false)
	const [gridLoading, setGridLoading] = useState<boolean>(false);
	const location = useLocation();

	useEffect(() => {
		const state = location.state as any;
		const id = state?.OrganizationID;
		const number = getOrgName(id);

		if (!!gridApi && !!number) {
			setSelectedOrgIds([id])
			setPhoneNumbers([])
			dispatch(updatePhonenumberSelectedOrgIDs([id]))
			// gridApi.setQuickFilter(number)
		}
		else {
			setSelectedOrgIds(SelectedOrganizations);
			setPhoneNumbers(organizationPhonenumbers)
		}
	}, [gridApi, Organizations])

	useEffect(() => {
		if (!!gridApi && gridLoading) {
			gridApi?.refreshCells({ force: true })
		}
	}, [gridLoading])

	const getPhoneNumbers = (ids) => {
		if ((PhoneNumbers.length === 0 || ids.length > 0) && !!gridApi) {
			gridApi.showLoadingOverlay();
		}
		PhoneNumberService.getGridByOrganizations(ids).then((res) => {
			if (res.status === 200) {
				setGridLoading(false)
				const data = res.data.map(mapToPhoneNumber)
				setPhoneNumbers(data);
				dispatch(updateOrganizationsphoneNumbers(data))
				dispatch(updatePhonenumberSelectedOrgIDs(ids))
				if (!!selectedOrgIds) {
					setRefreshHandler(() => getPhoneNumbers(selectedOrgIds));
				}
			}
		}).catch((err) => {
			setGridLoading(false)
			setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
		})

		if ((PhoneNumberGroups.length === 0 || ids.length > 0) && !!gridApi) {
			gridApi.showLoadingOverlay();
		}
		PhoneNumberGroupService.getGridByOrganizations(ids).then((res => {
			dispatch(updateOrganizationPhoneNumberGroups(res.data.map(maptoPhoneNumberGroups)))
		})).catch()
	}

	useEffect(() => {
		LoadProviders(dispatch);
		if (Organizations?.length === 0) {
			LoadOrganizations(dispatch);
		}
		LoadPlans(dispatch).then(res => {
			if (res.status === 200) {
				let plantype = res.data?.filter((item: any) => item.planType === 1)
				let addOntype = res.data?.filter((item: any) => item.planType === 2)
				setPlans(plantype.map(mapToPlan));
				setAddons(addOntype.map(mapToPlan));
			}
		})
		setHeaderTitle(pageTitles.PHONENUMBERS);
	}, []);

	useEffect(() => {
		if (selectedOrgIds.length === 0) {
			setShowMultiActionButtons(false)
			setGridLoading(true)
			setRefreshHandler(() => getPhoneNumbers(selectedOrgIds));
		}
		else {
			setShowMultiActionButtons(true)
		}

	}, [selectedOrgIds])

	useEffect(() => {
		setHeaderTitle(pageTitles.PHONENUMBERS);
		setHeaderCount(PhoneNumbers?.length || 0)
		setRefreshHandler(gridRefresh)
		return setHeaderTitle
	}, [gridApi, columnApi])

	const resetFilters = () => {
		setFilterOptions([])
		setSelectedFilterTypes([])
		initialFilterOptions()
	}

	const gridRefresh = () => {
		resetFilters()
		if (!!columnApi) {
			columnApi?.resetColumnState()
		}
		if (!!gridApi) {
			gridApi?.refreshCells({ force: true })
		}
		gridApi?.deselectAll();
		dispatch(updatePhonenumberSelectedOrgIDs([]))
		dispatch(updateOrganizationsphoneNumbers([]));
	}

	const searchPhoneNumbers = (e) => {
		setSearchValue(e.target.value)
		gridApi?.setQuickFilter(e.target.value)
	}

	const onGridReady = (params) => {
		setGridApi(params.api)
		setColumnApi(params.columnApi)
	}

	const getPhoneNumber = (id: string) => {
		return UtilityService.maskPhoneNumberOnLength(id);
	}

	const clearSelection = () => {
		if (!!gridApi && !!PhoneNumbers.length)
			gridApi.deselectAll();

		if (!!selectedOrgIds.length) {
			setShowMultiActionButtons(false)
			setSelectedOrgIds([])

			setPhoneNumbers([]);
			dispatch(updatePhonenumberSelectedOrgIDs([]))
			dispatch(updateOrganizationsphoneNumbers([]));

		}
	}

	const OrgColoumnDefs: ColDef[] = [
		{
			field: "Name",
			headerName: "Name",
			cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
		},
		{
			field: "OrganizationID",
			headerName: "Organization",
			valueGetter: (params: ValueGetterParams) => {
				return getOrgName(params.data.OrganizationID)
			},
			cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
			hide: IsMobileDevice,
		},
		{
			field: "ProductType",
			headerName: "Type",
			headerComponentParams: {
				template: selectedFilterTypes.includes("Type") ? `${HeaderTemplate.filterApplied(true)}` : ""
			},
			valueGetter: (params: ValueGetterParams) => {
				return params.data.ProductType === ProductType.LANDLINE_TEXTING ? ProductTypeLabel.LANDLINE_TEXTING : params.data.ProductType === ProductType.VOIP_TEXTING ? ProductTypeLabel.VOIP_TEXTING : params.data.ProductType === ProductType.MS_TEAMS_TEXTING ? ProductTypeLabel.MS_TEAMS_TEXTING : ProductTypeLabel.TOLL_FREE_TEXTING
			},
			cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
			hide: IsMobileDevice,
		},
		{
			field: "PhoneNumber",
			headerName: "Phone Number",
			valueFormatter: (params) => {
				return getPhoneNumber(params.data.PhoneNumber)
			},
			valueGetter: (params: ValueGetterParams) => {
				const raw = getPhoneNumber(params.data.PhoneNumber) || "";
				return ` ${raw}  ${raw.replace(/\D/g, "")} `;
			},
			cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
		},

		{
			field: "PhoneNumberGroup",
			headerName: "Line Group",
			valueGetter: (params: ValueGetterParams) => {
				const group = OrganizationPhoneNumberGroups.find(x => x.PhoneNumbers?.some(y => y.phoneNumberId === params.data.ID));
				return group ? group.GroupName : "---";
			},
			suppressSizeToFit: true,
			minWidth: IsMobileDevice ? null : 150,
			width: IsMobileDevice ? null : 150,
		},
		{
			field: "Status",
			headerName: "Status",
			valueGetter: (params: ValueGetterParams) => {
				return status(params.data.Status);
			},
			headerComponentParams: {
				template: selectedFilterTypes.includes("Status") ? `${HeaderTemplate.filterApplied(true)}` : ""
			},
			cellRendererSelector: (params: ICellRendererParams) => {
				if (params.data) {
					const label = status(params.data.Status);
					const variant = status(params.data.Status) === "Active" ? GridStatusLabelVariant.Active : status(params.data.Status) === "Inactive" ? GridStatusLabelVariant.Danger : status(params.data.Status) === "Payment due" ? GridStatusLabelVariant.Warning : GridStatusLabelVariant.Other;
					const Status = {
						component: StatusRenderer,
						params: {
							Variant: variant, Label: label, Id: params.data.ID
						}
					}
					return Status
				}
				return undefined
			},
			suppressSizeToFit: true,
			minWidth: 140,
			width: 140,
			maxWidth: 140,
		},
		{
			field: "Users",
			headerName: "Users",
			valueGetter: (params: ValueGetterParams) => {
				return params.data.Users
			},
			cellRenderer: (params: ICellRendererParams) => {
				const State = { PhoneNumberID: params.data.ID, selectedOrgId: params.data.OrganizationID }
				return <Link to={AppRoutes.USERS} state={State} className="color-vigenary-light">{params.data.Users}</Link>
			},
			cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
		},
		{
			field: "Current Plan",
			headerName: "Current Plan",
			autoHeight: true,
			valueGetter: (params: ValueGetterParams) => {
				return params.data.CurrentPlanID ? `${getCurrentPlanFromParams(params).PlanName}` : "---"
			},
			headerComponentParams: {
				template: selectedFilterTypes.includes("Plans") ? `${HeaderTemplate.filterApplied(true)}` : ""
			},
			cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
		},
		{
			field: "CreatedDateTime",
			headerName: "Updated Date",
			valueGetter: (params: ValueGetterParams) => {
				return UtilityService.convertDateToDay(params.data.CreatedDateTime)
			},
			cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
			hide: IsMobileDevice,
			sort: 'desc',
			comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.CreatedDateTime, nodeB.data.CreatedDateTime),
		},
		{
			field: "Action",
			maxWidth: 40,
			headerName: "",
			pinned: "right",
			lockPinned: true,
			lockPosition: "right",
			cellClass: "ag-cell-actions-style",
			headerClass: "bg-color-secondary",
			cellRenderer: params =>
				<ActionsRenderer
					MenuData={getMenuActions(params.data)}
					{...params}
				/>,
			resizable: false,
			sortable: false,
			hide: IsMobileDevice,
		},
	]

	const status = (status: PhoneNumberStatus): string => {
		return PhoneNumberStatusLabels[PhoneNumberStatus[status]];
	}

	const getOrgName = (OrgId: string) => {
		if (!!Organizations) {
			let x = Organizations?.find((x) => x.ID === OrgId)?.Name || "";
			return x;
		}
	}

	const getCurrentPlan = (phoneData?: PhoneNumberModel) => {
		if (!!phoneData) {
			setCurrentPlanDetails(phoneData.Plans?.find(x => x.PlanID === phoneData.CurrentPlanID && x.StatusType === RechargeStatus.ONGOING));
		}
	}

	const Addons = (plans: PlanHistoryModel[]) => {
		const AddOns = plans?.filter((item: PlanHistoryModel) => item.PlanType === PlanType.ADD_ON && item.StatusType === RechargeStatus.ONGOING);
		if (!AddOns.length) {
			return;
		}
		else {
			const AddOnInfo = AddOns?.map((plan: PlanHistoryModel) => plan.PlanID);
			const AddOnNames = addons?.filter((plan: PlanModel) => AddOnInfo.includes(plan.PlanID));
			setCurrentAddons(AddOnNames);
		}
	}

	const rehost = (phoneData?: PhoneNumberModel) => {
		if (!phoneData) {
			return;
		}
		navigate(AppRoutes.REHOST, { state: { ...phoneData, IsReHost: true }, replace: true })
	}

	const getCurrentPlanFromParams = (params) => {
		if (!!params.data.CurrentPlanID) {
			const id = params.data.Plans.find(x => x.PlanID === params.data.CurrentPlanID)
			return id
		}
		else {
			return " "
		}
	}

	const getMenuActions = (data: PhoneNumberModel) => {
		return [
			{
				Name: ActionLabels.CURRENT_PLAN_DETAILS,
				Icon: PlanDetailsIcon,
				OnClick: () => {
					setShowPlansDialog(true);
					setCurrentPhoneNumber(data as PhoneNumberModel);
					getCurrentPlan((data as PhoneNumberModel));
					Addons((data as PhoneNumberModel)?.Plans)
				},
				Hide: (((data as PhoneNumberModel)?.Status === PhoneNumberStatus.PAYMENT_DUE) || ((data as PhoneNumberModel)?.Status === PhoneNumberStatus.INACTIVE)),
			},

			{
				Name: ActionLabels.REHOST,
				Icon: ReHostIcon,
				OnClick: () => { rehost(data) },
				Hide: !(((data as PhoneNumberModel)?.Status === PhoneNumberStatus.INACTIVE || ((data as PhoneNumberModel)?.Status === PhoneNumberStatus.ACTIVE && (data as PhoneNumberModel)?.IsDeleted))),
			},
			{
				Name: ActionLabels.EDIT,
				Icon: EditIcon,
				OnClick: () => {
					setSelectedPhoneNumberId((data as PhoneNumberModel)?.ID);
					setEditPhoneNumber(true);
					setMobileMenu(false)
				},
			},
			{
				Name: ActionLabels.RECHARGE,
				Icon: RechargeIcon,
				OnClick: () => {
					recharge(data as PhoneNumberModel)
				},
				Hide: !((data as PhoneNumberModel)?.Status === PhoneNumberStatus.PAYMENT_DUE ||
					(data as PhoneNumberModel)?.Status === PhoneNumberStatus.ACTIVE ||
					(data as PhoneNumberModel)?.Status === PhoneNumberStatus.IN_PROGRESS ||
					(data as PhoneNumberModel)?.Status !== PhoneNumberStatus.INACTIVE),
			},

			{
				Name: ActionLabels.CANCEL_SUBSCRIPTION,
				Icon: CancelSubscriptionIcon,
				OnClick: () => {
					handleCancelSubscription(data as PhoneNumberModel)
				},
				Hide: !showCancelSubscription(data),
			},

			{
				Name: ActionLabels.DISABLE,
				Icon: DisableIcon,
				OnClick: () => {
					openConfirmDialog((data as PhoneNumberModel)?.ID, (data as PhoneNumberModel)?.IsDeleted)
				},
				Hide: ((data as PhoneNumberModel)?.Status === PhoneNumberStatus.INACTIVE),
			},

			{
				Name: ActionLabels.SETTINGS,
				Icon: SettingsIcon,
				OnClick: () => {
					setShowSettings(true);
					setSelectedPhoneNumberId((data as PhoneNumberModel)?.PhoneNumber);
					setMobileMenu(false);
				},
				Hide: ((data as PhoneNumberModel)?.Status === PhoneNumberStatus.INACTIVE),
			},

			{
				Name: ActionLabels.PLANS_HISTORY,
				Icon: TransactionHistoryIcon,
				OnClick: () => { GoToPlanHistory((data as PhoneNumberModel)?.ID) },
			},

			{
				Name: ActionLabels.VIEW_DETAILS,
				Icon: SettingsIcon,
				OnClick: () => {
					viewDetails(data.Name, (data as PhoneNumberModel)?.ID)
				},
				Hide: !((data as PhoneNumberModel)?.Status !== PhoneNumberStatus.INACTIVE),
			},
		]
	}

	const recharge = (phoneData?: PhoneNumberModel) => {
		if (!phoneData) {
			return;
		}
		// SettingsService.getManualsubscription(phoneData.OrganizationID, "MS").then(setting =>
		OrganizationService.getOrganizationById(phoneData?.OrganizationID).then(res => {
			let org = mapToOrganizationDetails(res.data);
			let data = {
				PhoneNumberID: phoneData?.ID,
				PhoneNumberToRecharge: phoneData?.PhoneNumber,
				ProductType: phoneData?.ProductType,
				Organization: org,
				IsRecharge: true,
				IsAddonRecharge: phoneData?.Status === PhoneNumberStatus.ACTIVE,
				PhonePlans: phoneData?.Plans,
				...org,
				CurrentPlanID: phoneData?.Plans?.find(x => x.StatusType === RechargeStatus.ONGOING && x.PlanType === PlanType.TIER)?.PlanID,
				SubscriptionID: phoneData?.Plans?.find(x => x.StatusType === RechargeStatus.ONGOING && x.PlanType === PlanType.TIER)?.SubscriptionID,
				// ManualPayment: setting.data.value.toLowerCase() === "true"
				ManualPayment: false

			} as unknown as IPaymentProps;

			navigate(AppRoutes.RECHARGE, { state: { ...data } })

		}).catch(error => { })
		// )
		// .catch(settingError => { })
	}
	const showCancelSubscription = (phoneData?: PhoneNumberModel) => {
		if (phoneData) {
			let currentPlan = phoneData && phoneData?.Plans ? phoneData?.Plans.find(x => x.PlanID === phoneData?.CurrentPlanID && x.StatusType === RechargeStatus.ONGOING) : undefined;
			return currentPlan && !currentPlan.IsItemCancelled;
		}
		return false;
	}

	const handleCancelSubscription = (phoneData?: PhoneNumberModel) => {
		if (phoneData) {
			let SubscirptionID = phoneData?.Plans?.find(x => x.StatusType === RechargeStatus.ONGOING && x.PlanType === PlanType.TIER)?.SubscriptionID || "";
			setShowCancelSubscriptionConfirmation(true);
			setSubscriptionIDToCancel(SubscirptionID);
			setMobileMenu(false);
		}
	}

	const GoToPlanHistory = (id: string) => {
		const pathname = location.pathname;
		if (SearchText) {
			navigate({
				pathname: pathname,
				search: `?q=${SearchText}`
			})
		}

		navigate({
			pathname: AppRoutes.PHONE_NUMBERS_PLAN_HISTORY.replace(':phoneID', id),
		})
	}

	const openConfirmDialog = (rowId: string, IsDeleted: boolean) => {
		let text = IsDeleted ? appNote.PHONENUMBER_ENABLE : appNote.PHONENUMBER_DISABLE;
		let btnName = IsDeleted ? "Enable" : "Disable";
		setShow(true);
		setSelectedPhoneNumberId(rowId);
		setText(text);
		// setDialogAction(btnName);
		setButtonName(btnName);
		setMobileMenu(false);
		setIsDeleted(IsDeleted);
		setIsLoading(false);
	}
	const viewDetails = (Name: string, ID: string) => {
		setViewDetails(true);
		setPhoneNumberName(Name);
		setSelectedPhoneNumberId(ID);
	};


	const handleRowClick = (row: PhoneNumberModel) => {
		if (IsMobileDevice) {
			setMobileMenu(true);
			// setClickRowData(row)
		}
	}

	const closeCurrentPlan = () => {
		setShowPlansDialog(false); setCurrentPlanDetails(undefined);
		setCurrentAddons(undefined)
		if (IsMobileDevice && !!TransactionHistory) {
			setShowTransactionHistory(true);
			setTransactionHistory(undefined)
		}
	}
	const closeViewDeatils = () => {
		setViewDetails(false);
	}

	const closeEditPhoneNumber = (value?: boolean) => {
		setEditPhoneNumber(false);
		if (value && !!selectedOrgIds) {
			getPhoneNumbers(selectedOrgIds)
		}
	}

	const closeConfirmDialog = (isConfim: boolean) => {
		if (!!isConfim) {
			let Name = PhoneNumbers?.find((x: PhoneNumberModel) => x.ID === SelectedPhoneNumberId)?.Name || '';
			let subscriptionId = PhoneNumbers?.find((x: PhoneNumberModel) => x.ID === SelectedPhoneNumberId)?.Plans?.find(x => x.PlanType === PlanType.TIER && x.StatusType === RechargeStatus.ONGOING)?.SubscriptionID || '';
			setIsLoading(true)
			PhoneNumberService.unHostPhoneNumber(SelectedPhoneNumberId, subscriptionId).then(res => {
				setShow(false);
				setSelectedPhoneNumberId("");
				setIsLoading(false);
				setToast(!IsDeleted ? ToasterTexts.PHONENUMBER_DISABLE_SUCCESS.replace('<Name>', Name) : ToasterTexts.PHONENUMBER_ENABLE_SUCCESS.replace('<Name>', Name), ToasterType.SUCCESS)
				if (!!selectedOrgIds) {
					getPhoneNumbers(selectedOrgIds);
				}

			});
		} else {
			setShow(false);
			setSelectedPhoneNumberId("");
			setIsLoading(false);;
		}
	};
	const closeAddOnConfirmation = () => {
		setShowCancelSubscriptionConfirmation(false);
		setTransactionHistory(undefined);
	}
	const cancelAddOnSubscription = () => {
		closeAddOnConfirmation();
		setToast(ToasterTexts.CANCELLING_ADDON, ToasterType.INFO)
		let itemId = `Pricing_${TransactionHistory?.PlanID || ""}`;
		let phoneId = TransactionHistory?.PhoneNumberID || "";
		let quantity = (PhoneNumbers?.find(x => x.ID === phoneId)?.Plans?.filter(y => y.PlanID === TransactionHistory?.PlanID && y.StatusType === RechargeStatus.ONGOING && y.IsItemCancelled).length || 0) + 1;
		ChargebeeService.cancelItem(itemId, [TransactionHistory?.ID || ""], phoneId, TransactionHistory?.SubscriptionID || "", quantity).then(res => {
			if (res.status === 200) {
				setToast(ToasterTexts.CANCEL_ADDON_SUCCESS, ToasterType.SUCCESS)
				setshowerrorCancelDialog(false);
			}
		}).catch(error => {
			if (error.response.status === 500) {
				setshowerrorCancelDialog(true);
			}
			else {
				setToast(ToasterTexts.CANCEL_SUBSCRIPTION_FAILED, ToasterType.DANGER)
				setshowerrorCancelDialog(false);
			}
		})
	}

	const closeSettings = () => {
		setShowSettings(false); setSelectedPhoneNumberId("");
	}

	const CloseMobileMenu = () => {
		setMobileMenu(false);
		setEditPhoneNumberData(undefined);
	}

	const closeCancelSubscriptionConfirmation = () => {
		setShowCancelSubscriptionConfirmation(false);
		setSubscriptionIDToCancel("");
	}
	const cancelSubscription = () => {
		closeCancelSubscriptionConfirmation();
		setToast(ToasterTexts.CANCELLING_SUBSCRIPTION, ToasterType.INFO)
		ChargebeeService.cancelSubscription([SubscriptionIDToCancel]).then(res => {
			if (res.status === 200) {
				setToast(ToasterTexts.CANCEL_SUBSCRIPTION_SUCCESS, ToasterType.SUCCESS)
				if (!!selectedOrgIds) {
					setRefreshHandler(() => getPhoneNumbers(selectedOrgIds));
				}
			}
		}).catch(error => {
			setToast(ToasterTexts.CANCEL_SUBSCRIPTION_FAILED, ToasterType.DANGER)
		})
	}


	const initialFilterOptions = () => {
		const filterData: CustomFilterCategory[] = [
			{
				Id: 2,
				Title: 'Status',
				IsSelectedAll: false,
				Options: _(PhoneNumbers)
					.map((row) => ({
						Key: "Status",
						Id: row.ID,
						Label: row.Status === PhoneNumberStatus.IN_PROGRESS ? PhoneNumberStatusLabels[PhoneNumberStatus[row.Status]] : row.Status === PhoneNumberStatus.PAYMENT_DUE ? PhoneNumberStatusLabels[PhoneNumberStatus[row.Status]] : row.Status === PhoneNumberStatus.ACTIVE ? PhoneNumberStatusLabels[PhoneNumberStatus[row.Status]] : PhoneNumberStatusLabels[PhoneNumberStatus[row.Status]],
						Value: row.Status,
						IsSelected: false
					}))
					.uniqBy('Label')
					.value()
			},
			{
				Id: 3,
				Title: 'Type',
				IsSelectedAll: false,
				Options: _(PhoneNumbers)
					.map((row) => ({
						Key: "ProductType",
						Id: row.ID,
						Label: row.ProductType === ProductType.LANDLINE_TEXTING ? ProductTypeLabel.LANDLINE_TEXTING : row.ProductType === ProductType.VOIP_TEXTING ? ProductTypeLabel.VOIP_TEXTING : row.ProductType === ProductType.MS_TEAMS_TEXTING ? ProductTypeLabel.MS_TEAMS_TEXTING : ProductTypeLabel.TOLL_FREE_TEXTING,
						Value: row.ProductType,
						IsSelected: false
					}))
					.uniqBy('Label')
					.value()
			}
		]

		setFilterOptions(filterData)
	}

	useEffect(() => {
		initialFilterOptions()
		setHeaderCount(PhoneNumbers?.length || 0)
	}, [Organizations, PhoneNumbers])

	const handleClickFilter = (event: React.MouseEvent<HTMLButtonElement>) => {

		if (IsMobileDevice) {
			setShowFilterOptions(true);
		}
		else {
			setAnchorEl(event.currentTarget)
		}
	}
	const handleCloseFilter = () => {
		setAnchorEl(null);
		setShowFilterOptions(false);
	}

	const handleApplyFilters = (filters) => {
		setFilterOptions(filters);
		const { result } = UtilityService.getFilterTypes(filters);
		setSelectedFilterTypes(result)
	};


	const downloadgriddataExcelFormat = () => {
		const data = PhoneNumbers.map(x => {
			const productType = x.ProductType === ProductType.LANDLINE_TEXTING ? ProductTypeLabel.LANDLINE_TEXTING : x.ProductType === ProductType.VOIP_TEXTING ? ProductTypeLabel.VOIP_TEXTING : x.ProductType === ProductType.MS_TEAMS_TEXTING ? ProductTypeLabel.MS_TEAMS_TEXTING : ProductTypeLabel.TOLL_FREE_TEXTING
			return {
				...x,
				Status: status(x.Status),
				ProductType: productType,
				CreatedDateTime: UtilityService.convertDateToDay(x.CreatedDateTime).toString(),
				OrganizationID: getOrgName(x.OrganizationID),
			}
		})

		const ExportReportHeaders = [
			{ label: "Name", value: "Name" },
			{ label: "Organization", value: "OrganizationID" },
			{ label: "Type", value: "ProductType" },
			{ label: "Phone Number", value: "PhoneNumber" },
			{ label: "Status", value: "Status" },
			{ label: "Users", value: "Users" },
			{ label: "Current Plan", value: "CurrentPlan" },
			{ label: "Updated Date", value: "CreatedDateTime" },
		]

		exportToExcel(ExportReportHeaders, data, `FalkonSMS-PhoneNumbers-${moment(UtilityService.getPreferredTimeZoneTimeNow(), ["MM-DD-YYYY"]
		).format("MM-DD-YYYY")}`, ToasterTexts.EXCEL_EXPORT_PHONENUMBERS_MESSAGE)
	};

	const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => { if (!!selectedOrgIds) return getPhoneNumbers(selectedOrgIds) })

	return (<>

		{
			editPhoneNumber && IsMobileDevice &&
			<SubpageHeaderComponent
				HeaderText={`${ShowSettings ? "PhoneNumber Settings" : editPhoneNumber ? "Edit PhoneNumber" : "Add PhoneNumber"}`}
				PreviousPage={ShowSettings ? closeSettings : closeEditPhoneNumber} />
		}
		{
			editPhoneNumber && IsMobileDevice ?
				<EditPhoneNumber
					SelectedPhoneNumberId={SelectedPhoneNumberId}
					HandleClose={closeEditPhoneNumber}
					EditPhoneNumber={editPhoneNumber}
					ProviderData={!!Providers && Providers.filter(x => x.Name !== "None")}
					OrganizationData={Organizations}
				/> :
				ShowSettings && IsMobileDevice ?
					<PhoneNumberSettings
						OnClose={closeSettings}
						Settings={ShowSettings}
						PhoneNumber={SelectedPhoneNumberId}
					/> :
					ShowPlansDialog && IsMobileDevice ?
						<CurrentPlanDetails
							CurrentAddons={CurrentAddons}
							Open={ShowPlansDialog}
							HandleClose={closeCurrentPlan}
							CurrentPlan={currentPlanDetails}
							CurrentPhoneNumber={CurrentPhoneNumber}
							IsMobileDevice={IsMobileDevice}
						/>
						: ViewDetails && IsMobileDevice ? (
							<PhoneSubscriberDetailsComponent {...PhoneDetailsData}
								PhoneNumberID={SelectedPhoneNumberId}
								CloseViewDeatils={closeViewDeatils}
								ViewDetails={ViewDetails}
								IsMobileDevice={IsMobileDevice}
								PhoneNumberName={PhoneNumberName}
								IsDarkMode={IsDarkMode}
							/>)
							: ShowFilterOptions && IsMobileDevice ? (
								<FilterComponent
									Filters={filterOptions}
									HandleApplyFilters={handleApplyFilters}
									OnClose={handleCloseFilter}
								/>
							) :
								<PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh}>
									<div className="d-flex flex-direction h-p-100 o-hidden justify-between">
										<PageHeaderComponent
											GridTitle={""}
											Count={PhoneNumbers.length}
											Actions={[{
												OnClick: () => navigate(AppRoutes.ADD_PHONE_NUMBER),
												ButtonLabel: buttonLabels.ADD_PHONENUMBER,
												Icon: AddNumberIcon,
												Variant: IsTeamsApp ? "disabled-btn" : "primary-btn",
												ClassName: `${IsTeamsApp ? "mr-2 disable" : "mr-2"}`,
											},
											{
												OnClick: () => { downloadgriddataExcelFormat() },
												ButtonLabel: "",
												Icon: DownloadedIcon,
												Variant: "secondary-btn"
											}]}
											ShowMultiActionButtons={ShowMultiActionButtons}
											MultiActionButtons={[
												{
													Name: buttonLabels.APPLY,
													Variant: "primary",
													ClassName: `${IsTeamsApp ? "mr-2 disable" : "mr-2"}`,
													Hide: !UserService.hasSysAdminRole(),
													OnClick: () => { getPhoneNumbers(selectedOrgIds) }
												},
												{
													Name: ActionLabels.CLEAR_SELECTION,
													Variant: "text",
													ClassName: "p-0 mr-1 w-space",
													Icon: MultiSelectCrossIcon,
													Hide: false,
													OnClick: () => clearSelection()
												}
											]}
											HandleFilter={handleClickFilter}
											ShowFilterIcon={true}
											IsFilterApplied={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length}
											onSearch={searchPhoneNumbers}
											searchValue={searchValue}
											PlaceHolder={IsMobileDevice ? "Search..." : "Find a Phone Number..."}
											showAutoComplete={true}
											autoCompleteOptions={Organizations?.filter(x => (x.Name !== null && !x.IsDeleted))}
											onChangeAutoComplete={(ids) => {
												setSelectedOrgIds(ids);
												// setPhoneNumbers([]);
												// dispatch(updatePhonenumberSelectedOrgIDs(ids))
												// dispatch(updateOrganizationsphoneNumbers([]));

											}}
											autoCompleteValue={selectedOrgIds}
										/>
										<GridComponent
											ColumnDefs={OrgColoumnDefs}
											RowData={PhoneNumbers}
											OnGridReady={onGridReady}
											IsPaginationEnabled={true}
											OnGridRowClick={handleRowClick}
											EmptyLabel={emptyLabels.PHONE_NUMBER}
											LockVisible={IsMobileDevice}
											filterOptions={filterOptions}
											IsFilterPresent={true}
											gridApi={gridApi}
										/>
										{
											ShowPlansDialog && !IsMobileDevice &&
											<CurrentPlanDetails
												CurrentAddons={CurrentAddons}
												Open={ShowPlansDialog}
												HandleClose={closeCurrentPlan}
												CurrentPlan={currentPlanDetails}
												CurrentPhoneNumber={CurrentPhoneNumber}
												IsMobileDevice={IsMobileDevice} />
										}
										{ViewDetails && (
											<PhoneSubscriberDetailsComponent {...PhoneDetailsData}
												CloseViewDeatils={closeViewDeatils}
												ViewDetails={ViewDetails}
												PhoneNumberID={SelectedPhoneNumberId}
												PhoneNumberName={PhoneNumberName}
												IsMobileDevice={IsMobileDevice}
												IsDarkMode={IsDarkMode} />)}
										{
											editPhoneNumber && !IsMobileDevice &&
											<EditPhoneNumber SelectedPhoneNumberId={SelectedPhoneNumberId}
												HandleClose={closeEditPhoneNumber}
												EditPhoneNumber={editPhoneNumber}
												ProviderData={!!Providers && Providers.filter(x => x.Name !== "None")}
												OrganizationData={Organizations}
											/>
										}
										{
											Show && <ConfirmDialog
												onClose={closeConfirmDialog}
												Show={Show}
												Text={Text}
												ButtonName={ButtonName}
												IsMobileDevice={IsMobileDevice}
												Loading={IsLoading}
											/>
										}
										{
											showerrorCancelDialog && <ConfirmDialog
												onClose={() => setshowerrorCancelDialog(false)}
												Show={showerrorCancelDialog}
												TextProps={() => <p>{ToasterTexts.UNABLE_CANCEL_SUBSCRIPTION} (<a href={`mailto: ${Config.SUPPORT_EMAIL}`} className={`color-primary-light`}>{Config.SUPPORT_EMAIL}</a>) to cancel this Add-on subscription.</p>}
												ButtonName={buttonLabels.OKAY}
												HideCancel={true}
												IsMobileDevice={IsMobileDevice}
											/>
										}
										{
											ShowSettings && !IsMobileDevice &&
											<PhoneNumberSettings
												OnClose={closeSettings}
												Settings={ShowSettings}
												PhoneNumber={SelectedPhoneNumberId}
											/>
										}
										{
											(ShowCancelSubscriptionConfirmation) &&
											<ConfirmDialog
												onClose={(flag) => {
													if (flag) {
														cancelSubscription();
													}
													else {
														closeCancelSubscriptionConfirmation();
													}
												}}
												Title={PlansHeaders.CONFIRM}
												Show={ShowCancelSubscriptionConfirmation}
												Text={appNote.CANCEL_SUBSCRIPTION_CONFIRMATION}
												ButtonName={buttonLabels.OKAY}
												IsMobileDevice={IsMobileDevice} />
										}
										{
											(ShowCancelAddOnConfirmation) &&
											<ConfirmDialog
												onClose={(flag) => {
													if (flag) {
														cancelAddOnSubscription();
													}
													else {
														closeAddOnConfirmation();
													}
												}}
												Title={PlansHeaders.CONFIRM}
												Show={ShowCancelAddOnConfirmation}
												Text={appNote.CANCEL_ADDON_CONFIRMATION}
												ButtonName={buttonLabels.OKAY}
												IsMobileDevice={IsMobileDevice} />
										}

										{
											!IsMobileDevice && Boolean(anchorEl) &&
											<Popover
												open={Boolean(anchorEl)}
												anchorEl={anchorEl}
												onClose={handleCloseFilter}
												anchorOrigin={{
													vertical: 'top',
													horizontal: 'right',
												}}
												transformOrigin={{
													vertical: 'top',
													horizontal: 'left',
												}}
												classes={{ paper: `min-w-40 ${ShowFilterOptions ? "min-h-40" : ""}` }}
											// BackdropProps={{
											// 	invisible: true,
											// 	onClick: (event) => event.stopPropagation(),
											// }}
											>
												<FilterComponent
													Filters={filterOptions}
													HandleApplyFilters={handleApplyFilters}
													OnClose={handleCloseFilter}
												/>
											</Popover>
										}
										{
											!ShowTransactionHistory && MobileMenu &&
											<Dialog
												fullWidth
												onClose={CloseMobileMenu}
												aria-labelledby="responsive-dialog-title"
												open={true}
												BackdropProps={{ style: { backgroundColor: "transparent" } }}
												classes={{ paper: "br-2 dialogue-shadow w-p-70 bg-color-menu-bg" }}
											>
												<DialogTitle className="dialog-header">
													<div className="h1 color-display-title d-flex" id="customized-dialog-title">
														{EditPhoneNumberData?.Name}
														<Tooltip title='Close' placement='bottom'>
															<span className={"ml-auto"}>
																<CancelIcon className={"c-pointer"}
																	onClick={CloseMobileMenu} />
															</span>
														</Tooltip>
													</div>
												</DialogTitle>
												<DialogContent className={"mln-1 o-hidden pt-0"}>
													<MenuItemRenderer MenuData={getMenuActions(EditPhoneNumberData)} OnClick={CloseMobileMenu} />
												</DialogContent>
											</Dialog>
										}
									</div>
								</PullToRefresh>}
	</>
	)
}

export default PhoneNumbersComponent;